export default class StickyHeader {
    constructor() {
        this.init();
    }

    scrollHandler() {
        let scrollTop = document.documentElement.scrollTop;

        if ( document.body.classList.contains( 'disable-sticky-header' ) ) {
            return;
        }

        let brandingHeight = document.body.querySelector( '.header__branding' ).offsetHeight;

        if ( scrollTop > brandingHeight ) {
            document.body.classList.add( 'enable-sticky-header' );
        } else {
            document.body.classList.remove( 'enable-sticky-header' );
        }
    }

    init() {
        if ( document.body.classList.contains( 'hide-sticky-header' ) ) {
            return;
        }

        window.addEventListener( 'scroll', this.scrollHandler );
    }
}